import { createContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

const CourseMenuContext = createContext();
const { Provider } = CourseMenuContext;

const basic = { showMenu: false, courseID: null, showContentsSubMenu: false };
const contents = { isDiscover: false, isAssess: false, isPerform: false, isFunFactor: false };
const insights = { isInSights: false };
const settings = { isSettings: false };

const config = { ...basic, ...contents, ...insights, ...settings };

function CourseMenuProvider({ children, location }) {
  const initial = Object.assign({}, config);
  const [menu, setMenu] = useState(initial);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const __tab = queryParams.get('tab');

    if (__tab === 'perform') {
      setMenu((x) => ({ ...x, isAssess: false, isPerform: true }));
    }

    return () => {};
  }, [location]);

  return (
    <Provider
      value={{
        menu,
        changeMenu: (data = {}) => setMenu(() => ({ ...initial, ...data })),
      }}
    >
      {children}
    </Provider>
  );
}

const CMP = withRouter(CourseMenuProvider);

export { CMP, CourseMenuContext };
